import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isAuthenticated = false; // Cached authentication state

  constructor(private http: HttpClient) {}

  /**
   * Checks if the session is valid.
   * Uses cache if already authenticated.
   */
  checkSession(): Observable<boolean> {
    let endpoint = environment.APIEndpoint
    if(!window.location.hostname.includes("localhost")) endpoint = environment.APIEndpointPROD;
    if (this.isAuthenticated) {
      return of(true);
    }

    return this.http.get(endpoint+'auth', { withCredentials: true }).pipe(
      map(() => {
        this.isAuthenticated = true;
        return true;
      }),
      catchError(() => {
        this.isAuthenticated = false;
        return of(false);
      })
    );
  }




  /**
   * Logs the user out and clears authentication state.
   */
  logout(): void {
    this.isAuthenticated = false;
  }
}
